/* Product recommendations loader.

   Liquid only fills `recommendations` when the section is requested through
   the recommendations route, so the block ships empty and fetches its own
   markup.

   Scheduling is deliberately geometry-independent. An IntersectionObserver
   was the obvious choice, but the placeholder is an empty custom element with
   a zero-area box, and a zero-area rect never reports as intersecting — the
   block simply never loaded. Idle time after `load` gives the same result
   (nothing competes with the product image) without depending on the
   element having a size.

   A product with no recommendations is a normal outcome, not an error —
   complementary pairings are curated per item — so the block stays empty
   instead of showing a heading with nothing under it. */
if (!customElements.get('tih-recs')) {
  customElements.define(
    'tih-recs',
    class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.loaded || !this.dataset.url) return;
        this.dataset.loaded = '1';

        const fetchRecs = () => {
          fetch(this.dataset.url)
            .then((r) => (r.ok ? r.text() : Promise.reject(r.status)))
            .then((text) => {
              const doc = new DOMParser().parseFromString(text, 'text/html');
              const fresh = doc.querySelector('tih-recs');
              if (fresh && fresh.innerHTML.trim()) this.innerHTML = fresh.innerHTML;
            })
            .catch(() => {
              /* Leave the block empty rather than a broken shell. */
            });
        };

        const schedule = () =>
          'requestIdleCallback' in window
            ? requestIdleCallback(fetchRecs, { timeout: 2000 })
            : setTimeout(fetchRecs, 500);

        if (document.readyState === 'complete') schedule();
        else window.addEventListener('load', schedule, { once: true });
      }
    }
  );
}
